// removed by extract-text-webpack-plugin
module.exports = {"ui":"field_ui_48zb3r"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/field/field.scss
// module id = 524
// module chunks = 0